import { useMutation } from "@tanstack/solid-query";
import { toast } from "solid-sonner";
import { axiosInstance } from "@/api/client";
import { getApiErrorMessage } from "@/api/utils/error";
import type { FreelancerSearchFilters } from "@/domains/company/active-search/types";
import type { JobSubcategoryKey } from "@/domains/freelance/taxonomy/types";

export type GenerateJobOfferBody = {
  freelancer_ids: string[];
  filters: FreelancerSearchFilters;
  instructions?: string;
};

export type GeneratedJobOfferDraft = {
  title: string;
  description: string;
  job_category: string;
  skills: string[];
  experience_level: string | null;
  daily_rate_min: number | null;
  daily_rate_max: number | null;
  payment_type: "daily";
  budget: null;
  effort: string;
  remote_policy: string;
  languages: string[];
  renewable: boolean;
  currency: string;
  project_type: null;
  duration: null;
  start_date: null;
  location: null;
  job_subcategory: JobSubcategoryKey[];
};

type GenerateJobOfferResponse = {
  success: true;
  data: GeneratedJobOfferDraft;
};

export const generateJobOfferFromProfiles = async (
  body: GenerateJobOfferBody,
) => {
  const { data } = await axiosInstance.post<GenerateJobOfferResponse>(
    "/v1/job-offer/ai/generate",
    body,
  );
  return data;
};

export const useGenerateJobOfferFromProfiles = () => {
  return useMutation(() => ({
    mutationFn: (body: GenerateJobOfferBody) =>
      generateJobOfferFromProfiles(body),
    onError: (error: unknown) => {
      toast.error(
        getApiErrorMessage(
          error,
          "Errore nella generazione dell'offerta di lavoro",
        ),
      );
    },
  }));
};
